import axios from "../http-client/axios";
import { SCORPIONS_URL } from "../urls/base-urls";


export async function updateCommunication(idStatement) {
  const resp = await axios.post(
    // `http://localhost:8289/communication-user`,
    `${SCORPIONS_URL}/communication-user`,
     idStatement
  );
  return resp.data;
}


export async function getCommunication() {
  const resp = await axios.get(
    `${SCORPIONS_URL}/communication`,
    // `http://localhost:8289/communication`,
  );
  return resp.data;
}


export async function deleteCommunication(id) {
  const resp = await axios.delete(
    `${SCORPIONS_URL}/admin/communication?id=${id}`,
    //`http://localhost:8289/admin/communication?id=${id}`,
  );
  return resp.data;
}


export async function getCommunications(page, size, search) {
  let query = `?page=${page}&size=${size}`;
  if (search != "" && search != null) {
    query = `?page=${page}&size=${size}&search=${search}`;
  }
  
  const resp = await axios.get(
    //`http://localhost:8289/admin/communication/list${query}`,
    `${SCORPIONS_URL}/admin/communication/list${query}`,
  );
  return resp.data;
}


export async function getCommunicationById(id) {
  const resp = await axios.get(
    //`http://localhost:8289/admin/communication/${id}`,
    `${SCORPIONS_URL}/admin/communication/${id}`,
  );
  return resp.data;
}


export async function repostCommunicationEvent(idCommunication) {

  const resp = await axios.get(
    //`http://localhost:8289/admin/communication/report?idComunication=${idCommunication}`,
    `${SCORPIONS_URL}/admin/communication/report?idCommunication=${idCommunication}`,
  );
  return resp.data;
}


export async function createCommunication(formData) {

  const resp = await axios.post(
     //`http://localhost:8289/admin/communication/create`,
    `${SCORPIONS_URL}/admin/communication/create`,
      builderRequestCreate(
      formData,
      formData.files,
    )
  );
  return resp.data;
}

export async function createCommunicationEvent(id, event, description) {

  const resp = await axios.post(
    // `http://localhost:8289/communication-event`,
    `${SCORPIONS_URL}/communication-event`,
    {
      "idCommunication": id,
      "event": event, 
      "description": description
    }
  );
  return resp.data;
}
export async function updateCommunicationById(formData) {

  const resp = await axios.put(
    // `http://localhost:8289/admin/communication/${formData.id}`,
    `${SCORPIONS_URL}/admin/communication/${formData.id}`,
      builderRequestCreate(
      formData,
      formData.files,
    )
  );
  return resp.data;
}

export async function downloadCommunicationReport(crms, startDate, endDate) {
  let query = `?crms=${crms}`
  if (startDate) { 
    query += `&dateStart=${startDate}`
  }
  if (endDate) { 
    query += `&dateEnd=${endDate}`
  }
  const resp = await axios({
    url: `${SCORPIONS_URL}/admin/communication/report-event-download${query}`,
    //url: `http://localhost:8289/admin/communication/report-event-download${query}`,
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  });
  return resp.data;
}

export async function getListCommunicationReport( crms,
          startDate,
          endDate,
          page,
          size) {
  let query = `?crms=${crms}`
  if (startDate) { 
    query += `&dateStart=${startDate}`
  }
  if (endDate) { 
    query += `&dateEnd=${endDate}`
  }
  const resp = await axios.get(
    //`http://localhost:8289/admin/communication/report-event${query}&page=${page}&size=${size}`,
    `${SCORPIONS_URL}/admin/communication/report-event${query}&page=${page}&size=${size}`,
  );
  return resp.data;
}


function builderRequestCreate(
  formData,
  attachments = [],
) {
  let formRequest = new FormData();
  const blob = new Blob([JSON.stringify(formData)],{
    type: 'application/json'
  });
  formRequest.append("request", blob);
  formRequest.append("file", attachments[0])
  return formRequest
}